<template>
    <div class="mt-5">
        <h2 class="text-center" v-if="(module_type_enabled && (module_type=='module_9' || module_type=='module_5_2' || module_type=='module_5_3' || module_type=='module_6' || module_type=='module_17')) || frontend_view_folder === 'frontend.skigd'">Welcome to {{site_name}}</h2>
        <h4 class="text-center" v-if="(module_type_enabled && (module_type=='module_9' || module_type=='module_5_2' || module_type=='module_5_3' || module_type=='module_6' || module_type=='module_17')) || frontend_view_folder === 'frontend.skigd'">Ready to rent skis and snowboards?</h4>
        <v-row class="justify-center mt-10"  v-if="(module_type_enabled && module_type=='module_9')">
            <v-btn color="error mr-15" @click="reservationType('multiday')">
                Daily Reservation
            </v-btn>
            <v-btn color="error" @click="openModal">
                1/2 Day / Night Skiing
            </v-btn>
        </v-row>
        <v-row class="justify-center mt-10" v-if="module_type_enabled && module_type=='module_5_3'" >
            <v-btn color="error mr-15" @click="reservationType('multiday')">
                Daily / Multiday
            </v-btn>
            <v-btn color="error" @click="setHalfDay">
                1/2 Day
            </v-btn>
        </v-row>
        <v-row class="justify-center mt-10"  v-if="module_type_enabled && module_type == 'module_18'">
            <v-btn color="error mr-15" @click="reservationType('multiday')">
                Daily Reservation
            </v-btn>
            <v-btn color="error" @click="reservationType('night')">
                Night Skiing
            </v-btn>
        </v-row>
        <v-row class="justify-center mt-10"  v-if="frontend_view_folder === 'frontend.skigd'">
            <v-btn color="error mr-15" @click="reservationType('multiday')">
                Daily / Multiday
            </v-btn>
            <v-btn color="error" @click="openModal">
                Afternoon / Night Skiing
            </v-btn>
        </v-row>
        <v-row class="justify-center mt-10"  v-if="module_type_enabled && (module_type !== 'module_9' && module_type=='module_6')">
            <v-btn color="error mr-15" @click="reservationType('multiday')">
                Multi day Reservation
            </v-btn>
            <v-btn color="error mr-15" @click="reservationType('day_hours')">
                Day Skiing (9am-4pm)
            </v-btn>
            <v-btn color="error" @click="reservationType('night_hours')">
                Night Skiing (4pm-9pm)
            </v-btn>
        </v-row>
        <v-row class="justify-center mt-10"  v-if="module_type_enabled && module_type=='module_5_2'">
            <v-btn color="error mr-15" @click="reservationType('multiday')">
                Daily / Multiday
            </v-btn>
            <v-btn color="error" @click="reservationType('afternoon')">
                1/2 Day
            </v-btn>
        </v-row>
        <v-row class="justify-center mt-10"  v-if="module_type_enabled && module_type=='module_17'">
            <v-btn color="error mr-15" @click="reservationType('multiday')">
                Daily / Multiday
            </v-btn>
            <v-btn color="error" @click="reservationType('night')">
                Night Skiing
            </v-btn>
        </v-row>
    </div>
</template>

<script>
import UiManagerMixin from "../../../mixins/UiManagerMixin";
import axios                 from "axios";
import StepperComponentMixin from "../../../mixins/StepperComponentMixin";

export default {
    name: "SingleDayType",
    mixins: [StepperComponentMixin, UiManagerMixin],
    data  : () => ({
        model: {
            full_name: '',
            dob      : null
        },
        tempReservation: null,
        notFoundMessage: '',
        response:{
            full_name:'',
        }
    }),
    computed: {
        site_name() {
            return this.$store.state.resources.config.site_name;
        },
        frontend_view_folder() {
            return this.$store.state.resources.config.frontend_view_folder;
        },
        module_type_enabled() {
            return this.$store.state.resources.config.module_type_enabled;
        },
        module_type() {
            return this.$store.state.resources.config.module_type;
        },
    },
    methods:{
        async searchCustomer(){
            if(this.model.full_name!=="" || this.model.dob!==null) {
                const searchResponse = await axios.get('/reservations/search_renter', {
                    params: this.model
                }).catch(error => {
                    return error.response;
                });

                if (searchResponse.data && searchResponse.data.success && searchResponse.data.exists && searchResponse.data.redirect) {
                    const response = await axios.get('/reservations/vue/load_reservation');
                    this.tempReservation = response.data.data;
                    this.$store.commit('set_return_customer_full_name', this.model.full_name);
                    this.$store.commit('set_return_customer_dob', this.model.dob);
                    this.notFoundMessage = '';

                    this.$nextTick(() => {
                        this.$refs['confirm-btn'].$el.focus();
                    })

                } else {
                    this.notFoundMessage = searchResponse.data.message;
                }
            }else{
                this.notFoundMessage = "Name and DOB are required";
            }
        },
        async skip(){
            await axios.post('/reservations/vue/reset_reservation');
            await this.moveToStep(3);
        },
        async confirm(){
            this.tempReservation.reservation.date_pickup=null;
            this.tempReservation.reservation.date_return=null;
            this.tempReservation.reservation.is_international_customer = false;
            this.tempReservation.reservation.reservees_number =  this.tempReservation.reservees.length || 1;
            this.tempReservation.reservation.email_confirmation = this.tempReservation.reservation.email;
            for(let key in this.tempReservation.reservation){
                if (!this.$store.state.model.reservation.is_seasonal || (this.$store.state.model.reservation.is_seasonal && (key !== 'date_pickup' && key !== 'date_return'))) {
                    this.$store.commit('set_model_value',{
                        path:'model.reservation.'+key,
                        value:this.tempReservation.reservation[key]
                    })
                }

            }
            this.$store.commit('set_model_value',{path:'model.reservees',value:this.tempReservation.reservees})
            await this.moveToStep(3);
        },
        async openModal(){
            this.ui__openModalByName({name:'dialog_single_day_type'});
        },
        async setHalfDay(){
            this.$store.commit('set_single_day_reservation', 'afternoon');
            let step_page = 3;
            await this.moveToStep(step_page);
        },
        async reservationType(res_type){
            this.$store.commit('set_single_day_reservation', res_type);
            await this.moveToStep(3);
        },
    },

}
</script>

<style scoped>

</style>
